import axios from "axios";
import { del, get, post, patch,  put } from "./evaluation_types_api_helper";
import * as url from "./evaluation_types_url_helper";





// Get features
export const getEvaluationTypes = () => get(url.GET_EVALUATION_TYPES);




export const addNewEvaluationType = evaluationType => post(url.ADD_NEW_EVALUATION_TYPE, evaluationType);



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateEvaluationType = evaluationType => patch(`${url.UPDATE_EVALUATION_TYPE}/${evaluationType.id}`,  evaluationType);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteEvaluationType = evaluationType => del(`${url.DELETE_EVALUATION_TYPE}/${evaluationType.id}`);






export {
  //getLoggedInUser,
  
  
};
